<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/peninsular-header.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt24-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Tu envío llega al día siguiente</p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista durante el siguiente
            día laborable al de su recogida (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/entpremium-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Para tus envíos entre empresas</p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega en Empresas prevista antes de las
            14:00h del siguiente día laborable al de su recogida. Envíos con origen y
            destino empresas con horario comercial publicado (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt1330-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Tu envío llega antes de las 14:00h</p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista antes de las 14:00h
            del siguiente día laborable al de su recogida (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt10-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Tu envío llega antes de las 10:00h</p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista antes de las 10:00h
            del día siguiente laborable al de su recogida (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt48-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Tu envío llega en 48h</p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista en un plazo de 48h
            (España y Portugal).
          </p>
        </div>
      </div>
      <div class="d-flex align-center">
        <img class="img-contain product-icon" :src="require('@/assets/EDP_icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Entrega Directa en Puntos Collectt Express </p>
          <p class="body-1 justify-text">
            Ahora tus clientes ya podrán elegir desde tu propia web, <b>entre más de 20.000 Puntos Collectt Express</b> para
            la entrega y recogida de sus envíos.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025/Footer'

export default {
  name: 'PeninsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularIntro')
  },
}
</script>
